let load = require('./helpers/browser/esm-js-loader');
module.exports = Promise.all([load("3yryI"), load("7Creg"), load("aHG2I"), load("bJvam"), load("i2ETv")]).then(() => parcelRequire('8SFVn'));